export default (text) => {
  if (!text) {
    return 0;
  }

  const words = text.split(/\s/).filter(word => word !== '');
  return words.length;
};
